var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0192308)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 52,
    height: 52,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAABmJLR0QA/wD/AP+gvaeTAAAEHUlEQVRYCe2ZS2gTURSGZya2pK0PBCtSYx8qZKVVlKxE62uloLgQBFHrRkEQ3IgoqAjqQnGpIvUB7lQQFyqoKCKiYnXhY1GsKU0fWFoRH4mhtBm/KZlwMnUmPu5NfSScP/ecc2/uOf+5NzM3GcMovUoVKFWgVIF/uQLmj5Krq6ubb9v2JtM0V/CZaWAK0CkDTN5HzNuZTOZcd3f3S+yCUpBQdXX1+IqKihaIrGe2guMZo0MyxG8ZHBzc1dvbmwoKEJhgTU1NZVlZ2X0mWAj+BGlNp9NNfX19Sb9kLL8Ox19eXn6K9k8hQyrGQnbLSUfxg+nX0dDQEGPvPqZfjnmNvXtoaOhJT0/Pe3Rtwu6Ywu6IEeAQWABcsckr1tXV1eo6ZDtOGlIfHh5uNnkJ3/NwONzU1tb2Wfi0qXxXBpj8RiQSuRcKhR6hNwJHTMuythiG0QpGiTXKk3XAZWlWHWmw9xaLzEjA7BtXt6+o+4CUvNxkhy8hBk0HOUkmkw9zRpEVtt4DT8iIx86ZQYTG50ah9Pf3f6EZE2lvb//kCTzRY+fMIEK5QX+T8s8R8r3KqVqV7EljKhcVO5VKsXP1bl0thGpraydTkJ2Q2Eg7G4xIZWWlTd9TjGOJROIKrXLRsuUgch0cNAwjRwbdEdxmjLfLEDvgOFRDCyGSLAeu9KLEQd4NGVL7OY1E8SsVXYQMjv3XuKM3dnZ2TgezQqHQDEjcFtlbnEbWCFuJqovQbr4jazs6Ol64Wcbj8Y8QOu7aTosdcVqV0EKIFbn7vSRZkYz0Q+iDtFXoWgj5JGZBYI/s49R8S9oq9GIRMuvr60+Q8HLgyl22pfLz4Th3dl0tRMJcIE6CZhFjgO23XdjKVK2E+C0zGyKXyXYecOU9W281PwveuA6VrTZCrMwS27avkewk4MorVmadLjJOEC3fIW6YjZC5SQBJ5hRkYjrJEM/QsUImZC4yeQVwJI29mQvAJcfQDeWEOKMtg8AckfhV9Lf4F9DmCaeHAW6+nXnO3zSUE+K4E4OQTGsDF4EN0uHqjDuDvg0oE+XfIZKsUZbdL0ykfIXI4R14BgoK5BMFB/3kAOWEOMcdJgcHNMUXq/gh9Ub8rwglZS2dPzukXUw9Go1O8MTz/Y8waIUScpKqqqpF0i6mziOUxZ54ebnJPksaHv2OtLkiHY2OrpQcokXP7owjcnLua3m5yb4gQucZaANX5lGpRzyaXJUN4vq1tE7xOF2s5q+vJwSYC1zJQOisa3hb0+uQNsk7Z7KN0jfWOjvlAufCZr88glbIYEW2U42nfh8eA/9jHrbtCIobSMh5lsmD2ibDMFpABoyVZFiZ0xR3KQ/CUkFJmEGdso/fOHOZdCtYiX8mCAOdkmbyOPFugbM8gnyFXZJSBUoVKFXgP6/AN3zQRloou6bPAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.661e7807263d00de9b9d8f14f51cebf4.svg";
export { ForwardRef as ReactComponent };